module.exports = __webpack_public_path__ + "img/system39-mini.b6732f0c.png";